module.exports = __webpack_public_path__ + "static/media/scr_send_money_share_in_chat.2f8f2339.png";